export default {
  expandedPush: 'Expanded push',
  open: 'Open',
  placeholder: 'String of characters{{index}}',
  variable: 'Variable',
  allButtons: 'All options',
  expandButtons: 'Expand buttons',
  allPossibilities: 'See all options',
};
